import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { LibSharedCommonModule } from 'projects/lib-shared-common/src/public-api';
import { SvcTotalsStatusComponent } from './svc-totals-status.component';
import { LibSharedComponentModule } from '@solvace/component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@NgModule({
  declarations: [
    SvcTotalsStatusComponent
  ],
  imports: [
    LibSharedCommonModule,
    LibSharedComponentModule,
    TranslocoModule,
    NgxSkeletonLoaderModule,
  ],
  exports: [
    SvcTotalsStatusComponent
  ],
})
export class SvcTotalsStatusModule { }
